const {Component} = require("react");

class Flash extends Component {

	/////////////////////////////////
	// Init
	/////////////////////////////////

	constructor(props) {
		super(props);

		this.state = {
			queue: [],
			pause: false,
			active: null,
			type: null,
		}
	}

	componentDidUpdate() {
		const state = this.state;

		if (state.queue.length > 0 && !state.active && !state.pause) {

			this.setState(({active, queue, type}) => {
				const msg = queue.shift()

				return {
					type:	msg.type,
					active:	msg.msg,
					queue:	queue,
				};

			}, this.scheduleUpdate);
		}
	}

	/////////////////////////////////
	// Interface methods
	/////////////////////////////////

	push(msg, type = 'info') {
		this.setState(({queue}) => {
			queue.push({msg: msg, type: type});

			return queue;
		});
	}

	error(msg) {
		this.push(msg, 'error');
	}

	warning(msg) {
		this.push(msg, 'warning');
	}

	info(msg) {
		this.push(msg, 'info');
	}

	success(msg) {
		this.push(msg, 'success');
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	scheduleUpdate = () => {
		this.timeoutState(5000,
			{active: null, pause: true},
			() => this.timeoutState(200, {pause: false})
		);
	}

	timeoutState(time, ...state) {
		setTimeout(() => {
			this.setState(...state)
		}, time);
	}

	/////////////////////////////////
	// Getters
	/////////////////////////////////

	get className() {
		return [
			"flash-msg-container",
			this.state.active ? 'active' : null,
			this.state.type || null,
		]
		.filter(el => typeof el === 'string' && el.length > 0)
		.join(' ');
	}

	/////////////////////////////////
	// Renders
	/////////////////////////////////

	renderMessage() {
		if (!this.state.active) return null;

		return (<p>{this.state.active}</p>);
	}

	render() {
		return (
			<div className={this.className} >
				{this.renderMessage()}
			</div>
		);
	}
}

module.exports = Flash;
